/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Overwrite_Selected_TitleInputs */



/**
* | output |
* | --- |
* | "Overwrite Selected Project" |
*
* @param {Explorer_Display_Overwrite_Selected_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_overwrite_selected_title = /** @type {((inputs?: Explorer_Display_Overwrite_Selected_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Overwrite_Selected_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ecraser le projet selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewähltes Projekt überschreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrivi il progetto selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезаписать выбранный проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sobrescribir el proyecto seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("覆盖选定项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したプロジェクトを上書き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित प्रोजेक्ट को ओवरराइट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobrescrever projeto selecionado")
	return /** @type {LocalizedString} */ ("Overwrite Selected Project")
});